export default __webpack_public_path__ + "static/media/LTC.281f9cd2.svg";